import { Alert, SelectedSource } from '@aloft/toolkit-shared';

import { SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

export const inconsistentSubjectSiteSize: AlertDefinition = ({
  propertyDataEntities,
  conflictedFields,
  order,
}) => {
  const subjectEntity = propertyDataEntities.subject as SubjectPropertyDataState;

  const foundConflict = Object.values(conflictedFields).find(
    (conflict) =>
      conflict.fieldName === 'editableData.site.area' && conflict.propertyId === 'subject',
  );

  if (!foundConflict) return [];

  const conflictIsResolved = (
    subjectEntity.subjectData.selectedSources?.editableData?.site?.area as
      | SelectedSource
      | undefined
  )?.conflictIsResolved;

  if (conflictIsResolved) return [];

  const triggers = getAlertTriggers({ fixRoute: 'features', order });
  const message = 'Subject Site Size appears inconsistent across data sources';

  return [
    {
      type: 'inconsistentSubjectSiteSize',
      message,
      severity: 'error',
      status: 'active',
      orderType: ['appraisify'],
      triggers,
      propertyID: 'subject',
      fixingInfo: {
        fixingMethod: ['comment'],
        commentAlwaysRequired: false,
        targetCellKey: 'subject-editableData.site.area',
        targetCellTooltip: 'Click to verify or select a different value',
        pairedCostRouteItem: 'features',
        tips: 'Review all sources and reconcile the conflicts, or provide an explanation for the selected values.',
      },
    } as Alert,
  ];
};
